module.exports = __webpack_public_path__ + "img/envelope-fill.aace3ab0.svg";